window.am = window.am || {};

window.am.requiredAdvanced = new function () {
    var that = this;
    that.validatioName = 'requiredadvanced';

    that.init = function () {
        if (!$.validator) {
            return;
        }

        var adapters = $.validator.unobtrusive.adapters;

        $.validator.addMethod(
            that.validatioName,
            function (value, element, params) {
                var allowEmptyStrings = params == "true" || params == true;

                if (allowEmptyStrings) {
                    return true;
                }

                /* Call base required function from jquery validation. */
                return $.validator.methods.required.call(this, value, element);
            },
            'This field is required.');

        adapters.addBool(that.validatioName);
        adapters.addSingleVal(that.validatioName, "allowemptystrings");
    }
}

window.am.requiredAdvanced.init();